<template>
  <span
    class="annotation-letter"
    :style="{ backgroundColor: backgroundColorMap[index] }"
  >{{ annotationLetter }}</span>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    backgroundColorMap: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    }
  },
  computed: {
    annotationLetter() {
      // ASCII value of 'A' is 65
      const startingCharCode = 65
      // Convert the index to the corresponding letter
      return String.fromCharCode(startingCharCode + this.index)
    },
  },
}
</script>

<style lang="scss" scoped>
.annotation-letter {
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  color: #fff;
  border-radius: 4px;
  width: 20px;
  min-width: 20px;
  display: inline-block;
  text-align: center;
  background-color: #000;
}
</style>
